// index.ts
import { installExtension } from "@juitnow/lib-fetch-client";
export * from "../types/validators.mjs";
var FormsImpl = class {
  constructor(_http) {
    this._http = _http;
  }
  async b2bRegistration(form) {
    await this._http.post("/forms/v1/b2b_registration", form);
  }
};
installExtension("forms", FormsImpl);
//# sourceMappingURL=index.mjs.map
